import { Service } from '@roc/client-portal-shared/services';

const url = {
  MERS_ONBOARDING_DOCUSIGN: '/api/v1/loan/mersOnboarding/createMersOnboardongDocusign',
  CONFIRM_DOCUSIGN: '/api/v1/loan/mersOnboarding/confirmDocusign',
  GENERATE_MERS_DOCUMENT: '/api/v1/loan/mersOnboarding/generateMersDocument',
};

export class MersOnboardingService extends Service {
  url;
  constructor() {
    super();
    this.url = url;
  }
  submitMersOnboardingFormToDocusign(request, companyId) {
    return this.post(`${this.url.MERS_ONBOARDING_DOCUSIGN}`, request);
  }

  confirmDocusign(signatoryTitle) {
    return this.post(`${this.url.CONFIRM_DOCUSIGN}?signatoryTitle=${signatoryTitle}`, null);
  }

  generateMersDocument(data) {
    return this.post(url.GENERATE_MERS_DOCUMENT, data);
  }

}